// TODO : Need translation
// Options for Name MisMatch Reason Options
export const NAME_MISMATCH_REASON_OPTIONS = [
  "Spelling error in PAN name",
  "Account is registered under a different entity",
  "Full name differs from common name",
  "Others",
];
